import { render, staticRenderFns } from "./SmartBanner.vue?vue&type=template&id=0fadac10&"
import script from "./SmartBanner.vue?vue&type=script&lang=js&"
export * from "./SmartBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports